import { call } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import axiosServices from '../../../services/axiosServicesLocais';
import { Response } from '../../../interfaces/index';
import store from '../..';
import { setCategory } from './actions';

export function* getCategory() {
  try {
    const response: Response = yield call(axiosServices.get, '/admin/categorias-locais/v1/categorias-validas');
    store.dispatch(setCategory(response.data.data));
  } catch (err: any) {
    toast.error(`⚠ ${err?.response.data?.notifications?.map((item: any) => `${item.message}\n`)}`);
  }
}
